var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-label-container"},[_c('span',{staticClass:"d-block mr-2"},[_vm._v(_vm._s(_vm.name))]),(_vm.is_default)?_c('a-badge',{attrs:{"count":"Default","number-style":{
      backgroundColor: '#fff',
      color: '#999',
      boxShadow: '0 0 0 1px #d9d9d9 inset',
    }}}):_vm._e(),_c('PingDot',{attrs:{"show":_vm.error_validate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }